<div class="container-fluid container-background">
    <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 bgwhite">
            <div class="outer">
                <div class="middle">
                    <div class="login-form-container">
                        <div class="login-header-title">
                            <i class="zmdi zmdi-lock zdmi-fw"></i>
                            Change email verification
                        </div>
                        <sync-error [errcode]="errcode"></sync-error>
                        <p *ngIf="spinner">
                            <i class="fa fa-spin fa-spinner"></i>
                            Verifying... Please wait...
                        </p>
                        <p *ngIf="verified">
                            Your email address has been updated successfully.
                            <br />
                            <a class="syncblue" routerLink="/login"
                                >Log in to the control panel.</a
                            >
                        </p>

                        <div *ngIf="errcode">
                            Changing your email failed. Please
                            <a
                                class="syncblue"
                                href="https://www.sync.com/support"
                                >contact support</a
                            >
                            immediately for further assistance.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
